var _defs, _path, _circle, _path2, _path3, _path4, _path5, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPtEu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 64,
    cy: 64.21,
    r: 63.57
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 64,
    cy: 61.23,
    r: 67.35,
    transform: "rotate(-.58 63.9 61.572)"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#fff}.cls-4{fill:#ef5252}.cls-6{fill:#437ae8}.cls-8{fill:none}.cls-9{fill:#e6ea42}\n        "))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-1)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M-15.3-7.9v139.61h162.96V-7.9H-15.3z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#19a319"
    },
    d: "M-7.81-8.64h61.57v148.99H-7.81z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 64,
    cy: 61.23,
    r: 67.35,
    transform: "rotate(-.56 64.162 60.68)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M85.47 63.99c.13-.09.24-.18.32-.27.03-.02.04-.04.04-.07V62.83s0-.04-.02-.06c-.12-.14-.27-.28-.43-.42-.25-4.14-1.3-8.07-2.99-11.64.15-.08.25-.14.31-.19 0 0 .02 0 .03-.01.02-.02.03-.05.02-.07s0-.03 0-.04l-.52-.91c-.09-.1-.26-.21-.48-.33l-.54-.94c.08-.05.16-.1.21-.14h.02c.04-.03.05-.08.02-.12l-.74-1.18s-.01-.02-.02-.02c-.24-.18-.55-.36-.93-.55-5.41-7.75-14.18-12.98-24.19-13.55v-.45a.09.09 0 0 0-.09-.09h-.69s-.05 0-.06.03c-.02.02-.03.04-.03.06v.27H52.9v-.27a.09.09 0 0 0-.09-.09h-.69a.09.09 0 0 0-.09.09v.45c-9.93.54-18.66 5.69-24.09 13.33-.42.02-.75.11-.98.28-.01 0-.02.02-.02.03l-.03.05-.38.67-.06.11c-.08.21-.05.46.06.75l-1.54 2.86c-.12.02-.23.06-.32.11-.03 0-.07.01-.08.04l-.37.65c-.12.19-.14.42-.08.68.03.13.09.28.17.44a31.573 31.573 0 0 0-2.15 9.54c-.24.21-.4.41-.46.6v.91s.02.06.04.08c.06.04.14.08.22.12v1.19c-.13.14-.22.28-.27.41v.91s.02.06.04.08c.11.07.27.15.45.23.32 4.21 1.47 8.2 3.28 11.8-.13.16-.2.31-.22.46 0 .02 0 .03.01.05l.37.66s.03.03.05.04c.1.04.21.07.32.11l.77 1.25c-.07.1-.12.2-.14.29v.06l.38.65s.02.03.04.04c.23.1.48.2.73.3 5.42 7.74 14.2 12.96 24.22 13.51v.49c0 .05.04.09.09.09h.7c.05 0 .09-.04.09-.09v-.28h1.81v.28c0 .05.04.09.09.09h.69c.05 0 .09-.04.09-.09v-.5c9.04-.51 17.09-4.84 22.54-11.39.11 0 .19.01.27.01.22 0 .45-.04.61-.24l.03-.02s.02-.01.02-.02l.39-.61c.09-.13.11-.3.07-.5 0-.03-.02-.06-.03-.09l1.8-2.79h.12c.18 0 .31-.03.38-.1l.02-.02.05-.08.05-.09.38-.57s.03-.03.03-.06c.12-.27.07-.63-.13-1.06 1.74-3.51 2.83-7.39 3.16-11.48.2-.12.34-.24.44-.35.03-.02.05-.04.05-.07V65.59s0-.04-.02-.06c-.1-.11-.21-.23-.33-.34v-1.15Zm-22.6 26.9a27.99 27.99 0 0 1-7.29 1.45v-5.7c4.93-.12 10.44-.67 14.22-1.45.85-.14 2.14-.41 3.58-.75a28.238 28.238 0 0 1-6.11 4.51c-1.39.76-2.86 1.4-4.39 1.93ZM28.41 76.42c-1.25-2.59-2.1-5.41-2.51-8.36 2.31.7 5.42 1.46 9.14 2 4.78.73 10.1 1.15 15.85 1.25.38.22.75.45 1.12.67v1.08c-8.14.12-14.61.95-20.21 2.58-.66.19-1.96.59-3.24 1.09-.05-.09-.1-.18-.14-.28l-.02-.03Zm53.22-16.34c.02.1.03.21.04.31-1.93-.71-4.42-1.38-7.43-1.98-5.6-1.09-12.17-1.72-18.66-1.81v-1.77c5.53-.08 10.84-.5 15.8-1.25 3.06-.53 5.71-1.16 7.68-1.71.83 1.69 1.5 3.48 1.98 5.34.22.92.41 1.88.58 2.89Zm-51.2 19.86c.8-.32 1.64-.6 2.36-.8 5.45-1.56 11.91-2.38 19.22-2.44v6.29c-6.92-.24-13.88-1.17-21.46-2.88l-.12-.18Zm-4.79-15.69v-.18c2.14-.8 4.87-1.53 7.42-2.03.75-.15 1.51-.28 2.3-.41 2.6 1.72 5.64 3.66 9.15 5.82-3.3-.21-6.42-.54-9.33-.98-1.66-.27-6.04-1.04-9.54-2.13v-.08ZM77.2 48.63c-1.71.52-3.97 1.06-6.77 1.44-3.23.46-8.18 1.07-14.86 1.16v-5.12c6.73.05 12.25.47 16.43 1.25 1.9.36 3.61.74 5.11 1.13.03.04.06.09.09.13ZM52.01 63.97v.69c-2.24-1.36-4.52-2.77-6.76-4.17.19-.01.39-.03.59-.04 2 1.1 4.07 2.28 6.18 3.52Zm3.56 2.84v-.68c.84.52 1.67 1.03 2.47 1.54-.32 0-.65.02-.97.02-.5-.29-1-.58-1.5-.88Zm-6.84-12.05c1.08.04 2.17.06 3.28.08v1.71c-1.08-.6-2.18-1.2-3.28-1.79Zm6.84 21.95c1.76.02 3.45.07 5.07.17 3.45 1.87 6.59 3.47 9.27 4.71-.33.05-.65.11-1 .16-.45.06-.89.12-1.32.18-3.24.45-6.33.88-12.02 1.06V76.7Zm-3.56-25.47c-4.66-.06-8.46-.33-11.31-.63-2.4-1.18-4.67-2.21-6.65-3 .4-.08.81-.17 1.23-.25 4.66-.81 10-1.21 16.72-1.25v5.13Zm11.02 19.81c.08 0 .15 0 .23-.01.37.24.73.49 1.09.73-.43-.23-.87-.47-1.32-.71Zm5.84-4.1c-3.22-2.2-6.77-4.48-10.38-6.67 5.47.21 10.87.8 15.58 1.72 2.16.43 5.32 1.17 7.87 2.17v.24c-2.64.81-6.13 1.6-8.9 2-1.35.21-2.74.39-4.17.55Zm-37.65-8.16c-1.99.45-3.8.97-5.3 1.5.23-1.63.6-3.21 1.1-4.74 1.09.93 2.49 2.01 4.21 3.23Zm20.79 27.83v5.72a28.077 28.077 0 0 1-17.94-8.02c4.71 1.13 10.86 2.08 17.94 2.3Zm27.65-11.38c-1.61-1.52-3.84-3.31-6.48-5.25 3.26-.53 6.23-1.17 8.48-1.82-.14 1.02-.34 2.02-.59 3-.39 1.42-.87 2.78-1.41 4.06Zm-8.17-31.52c-4.18-.75-9.66-1.17-15.92-1.22v-6.35a28.08 28.08 0 0 1 17.91 8c-.65-.15-1.31-.3-1.99-.43ZM52.01 42.5c-6.39.08-11.94.53-16.15 1.29-.62.12-1.22.25-1.79.38 4.69-4.61 10.98-7.59 17.95-8.03v6.36Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.84 67.76c0 5.19 2.13 9.89 5.57 13.32 3.45 3.44 8.14 5.61 13.34 5.61s9.97-2.12 13.41-5.55c3.44-3.43 5.57-8.15 5.57-13.36V42.51l-37.89-.05v25.3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M35.55 67.79c0 4.98 2.06 9.5 5.35 12.78 3.3 3.29 7.85 5.33 12.83 5.33s9.54-2.03 12.83-5.3c3.29-3.28 5.33-7.8 5.33-12.78V43.31H35.57l-.02 24.48m29.04-17.15v17.25h-.01c0 .43-.03.93-.08 1.35-.3 2.47-1.43 4.62-3.11 6.29-1.97 1.96-4.68 3.17-7.67 3.17s-5.63-1.26-7.6-3.22c-2.03-2.02-3.2-4.78-3.2-7.64V50.6l21.67.04Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M53.73 85.99c-4.84 0-9.42-1.9-12.89-5.36-3.47-3.45-5.38-8-5.38-12.82h.16c0 4.78 1.89 9.29 5.33 12.71 3.44 3.42 7.98 5.31 12.77 5.31s9.36-1.88 12.78-5.28c3.4-3.39 5.29-7.88 5.3-12.65V43.4H35.65l-.02 24.4h-.16l.02-24.57h36.48v24.6c0 4.84-1.9 9.4-5.35 12.83a18.141 18.141 0 0 1-12.89 5.33Zm-.01-7.2c-2.84 0-5.56-1.15-7.66-3.25-2.05-2.04-3.22-4.85-3.22-7.7V50.52h.08l21.71.04.05.05v17.28c-.01.45-.04.95-.09 1.36-.29 2.39-1.37 4.58-3.13 6.34-2.07 2.06-4.82 3.2-7.73 3.2Zm-10.73-28.1v17.16c0 2.81 1.16 5.57 3.18 7.58 2.07 2.06 4.75 3.2 7.55 3.2s5.58-1.12 7.62-3.15c1.74-1.73 2.8-3.89 3.09-6.24.05-.4.08-.89.08-1.34V50.73l-21.5-.04Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "castle"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M37.9 49.71c.04-1.76 1.29-2.18 1.3-2.18 0 0 1.35.45 1.35 2.2l-2.65-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m36.82 47.55-.22 2.02h1.32c.01-1.67 1.27-1.95 1.3-1.94.03 0 1.27.37 1.31 1.95h1.32l-.24-2.04h-4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M38.01 49.66h-1.49l.23-2.12.02-.05.06-.02h4.86l.26 2.19h-1.49v-.08c-.03-1.53-1.23-1.87-1.24-1.87 0 0-1.19.24-1.21 1.87v.08Zm2.6-.16h1.16l-.22-1.88h-2.1c.38.18 1.11.72 1.17 1.88Zm-3.91 0h1.15c.04-1.25.75-1.71 1.14-1.87H36.9l-.2 1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M36.52 49.59h5.41c.11 0 .21.11.21.25s-.09.25-.21.25h-5.41c-.11 0-.21-.11-.21-.25s.09-.25.21-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.92 50.17h-5.41c-.16 0-.29-.15-.29-.33s.13-.33.29-.33h5.41c.16 0 .29.15.29.33s-.13.33-.29.33Zm-5.41-.5c-.07 0-.13.08-.13.17s.06.17.13.17h5.41c.07 0 .13-.08.13-.17s-.06-.17-.13-.17h-5.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M38.48 49.58c0-1.06.72-1.36.73-1.36 0 0 .75.31.75 1.36h-1.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M40.04 49.66h-1.56v-.08h-.08c0-.69.29-1.07.53-1.27 0 0 .21-.17.29-.16.06 0 .81.36.82 1.43v.08Zm-1.48-.16h1.32c-.04-.81-.54-1.12-.67-1.19-.12.06-.61.37-.64 1.19ZM36.63 46.71h5.18c.11 0 .2.1.2.22s-.09.22-.2.22h-5.18c-.11 0-.2-.1-.2-.22s.09-.22.2-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.82 47.24h-5.18c-.15 0-.28-.14-.28-.3s.12-.3.28-.3h5.18c.15 0 .28.14.28.3s-.12.3-.28.3Zm-5.18-.45c-.06 0-.12.07-.12.15s.05.15.12.15h5.18c.06 0 .12-.07.12-.15s-.05-.15-.12-.15h-5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M36.74 47.17h4.96c.1 0 .19.1.19.22s-.09.22-.19.22h-4.96c-.1 0-.19-.1-.19-.22s.09-.22.19-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.7 47.69h-4.96c-.15 0-.27-.14-.27-.3s.12-.3.27-.3h4.96c.15 0 .27.14.27.3s-.12.3-.27.3Zm-4.96-.45c-.06 0-.11.07-.11.14s.05.15.11.15h4.96c.06 0 .11-.07.11-.15s-.05-.14-.11-.14h-4.96ZM38.34 43.79h.39v.28h.29v-.28h.4v.28h.29v-.28h.4v.64c0 .1-.08.17-.18.17h-1.41c-.09 0-.18-.08-.18-.17v-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.93 44.67h-1.41c-.14 0-.26-.11-.26-.25v-.68l.05-.04h.5v.28h.13v-.28h.56v.28h.13v-.28h.56v.72c0 .14-.11.25-.26.25Zm-1.51-.8v.55s.05.09.1.09h1.41s.1-.03.1-.09v-.56h-.24v.28h-.45v-.28h-.24v.28h-.45v-.28h-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m39.82 44.64.09 2.06h-1.37l.09-2.06h1.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.99 46.78h-1.54l.1-2.22h1.35l.1 2.22Zm-1.37-.16h1.21l-.08-1.89h-1.04l-.08 1.89Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m38.14 45.6.04 1.11h-1.32l.04-1.11h1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m36.78 46.79.04-1.27h1.39l.05 1.27h-1.48Zm.2-1.11-.03.95h1.15l-.04-.95h-1.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cp1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m41.53 45.6.04 1.11h-1.32l.04-1.11h1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m40.17 46.79.04-1.27h1.39l.05 1.27h-1.48Zm.2-1.11-.03.95h1.15l-.04-.95h-1.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cp2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M36.66 44.79h.38v.28h.28v-.28h.39v.28h.28v-.28h.39v.64c0 .1-.08.17-.17.17h-1.38c-.09 0-.18-.08-.18-.17v-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M38.22 45.68h-1.38c-.14 0-.26-.11-.26-.25v-.68l.05-.04h.49v.28h.12v-.29h.55v.29h.12v-.28h.55v.72c0 .14-.11.25-.25.25Zm-1.48-.8v.55s.05.09.1.09h1.38s.09-.03.09-.09v-.56h-.23v.28h-.44v-.28h-.23v.28h-.44v-.28h-.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cp2-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M40.05 44.79h.38v.28h.28v-.28h.39v.28h.28v-.28h.39v.64c0 .1-.08.17-.17.17h-1.38c-.09 0-.18-.08-.18-.17v-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.6 45.68h-1.38c-.14 0-.26-.11-.26-.25v-.68l.05-.04h.49v.28h.12v-.29h.55v.29h.12v-.28h.55v.72c0 .14-.11.25-.25.25Zm-1.48-.8v.55s.05.09.1.09h1.38s.09-.03.09-.09v-.56h-.23v.28h-.44v-.28h-.23v.28h-.44v-.28h-.22Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.09 45.3c0-.2.28-.2.28 0v.49h-.28v-.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M37.38 46.01c0-.19.27-.2.26 0v.38h-.26v-.38",
    id: "cp3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M40.78 46.01c0-.19.27-.2.26 0v.38h-.26v-.38",
    id: "cp3-2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "castle-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M37.9 64.48c.04-1.76 1.29-2.18 1.3-2.18 0 0 1.35.45 1.35 2.2l-2.65-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m36.82 62.33-.22 2.02h1.32c.01-1.67 1.27-1.95 1.3-1.94.03 0 1.27.37 1.31 1.95h1.32l-.24-2.04h-4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M38.01 64.44h-1.49l.23-2.12.02-.05.06-.02h4.86l.26 2.19h-1.49v-.08c-.03-1.53-1.23-1.87-1.24-1.87 0 0-1.19.24-1.21 1.87v.08Zm2.6-.16h1.16l-.22-1.88h-2.1c.38.18 1.11.72 1.17 1.88Zm-3.91 0h1.15c.04-1.25.75-1.71 1.14-1.87H36.9l-.2 1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M36.52 64.37h5.41c.11 0 .21.11.21.25s-.09.25-.21.25h-5.41c-.11 0-.21-.11-.21-.25s.09-.25.21-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.92 64.95h-5.41c-.16 0-.29-.15-.29-.33s.13-.33.29-.33h5.41c.16 0 .29.15.29.33s-.13.33-.29.33Zm-5.41-.5c-.07 0-.13.08-.13.17s.06.17.13.17h5.41c.07 0 .13-.08.13-.17s-.06-.17-.13-.17h-5.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M38.48 64.36c0-1.06.72-1.36.73-1.36 0 0 .75.31.75 1.36h-1.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M40.04 64.44h-1.56v-.08h-.08c0-.69.29-1.07.53-1.27 0 0 .21-.17.29-.16.06 0 .81.36.82 1.43v.08Zm-1.48-.16h1.32c-.04-.81-.54-1.12-.67-1.19-.12.06-.61.37-.64 1.19ZM36.63 61.49h5.18c.11 0 .2.1.2.22s-.09.22-.2.22h-5.18c-.11 0-.2-.1-.2-.22s.09-.22.2-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.82 62.02h-5.18c-.15 0-.28-.14-.28-.3s.12-.3.28-.3h5.18c.15 0 .28.14.28.3s-.12.3-.28.3Zm-5.18-.45c-.06 0-.12.07-.12.15s.05.15.12.15h5.18c.06 0 .12-.07.12-.15s-.05-.15-.12-.15h-5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M36.74 61.94h4.96c.1 0 .19.1.19.22s-.09.22-.19.22h-4.96c-.1 0-.19-.1-.19-.22s.09-.22.19-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.7 62.47h-4.96c-.15 0-.27-.14-.27-.3s.12-.3.27-.3h4.96c.15 0 .27.14.27.3s-.12.3-.27.3Zm-4.96-.45c-.06 0-.11.07-.11.14s.05.15.11.15h4.96c.06 0 .11-.07.11-.15s-.05-.14-.11-.14h-4.96ZM38.34 58.57h.39v.28h.29v-.28h.4v.28h.29v-.28h.4v.64c0 .1-.08.17-.18.17h-1.41c-.09 0-.18-.08-.18-.17v-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.93 59.45h-1.41c-.14 0-.26-.11-.26-.25v-.68l.05-.04h.5v.28h.13v-.28h.56v.28h.13v-.28h.56v.72c0 .14-.11.25-.26.25Zm-1.51-.8v.55s.05.09.1.09h1.41s.1-.03.1-.09v-.56h-.24v.28h-.45v-.28h-.24v.28h-.45v-.28h-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m39.82 59.42.09 2.06h-1.37l.09-2.06h1.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.99 61.56h-1.54l.1-2.22h1.35l.1 2.22Zm-1.37-.16h1.21l-.08-1.89h-1.04l-.08 1.89Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cp1-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m38.14 60.38.04 1.11h-1.32l.04-1.11h1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m36.78 61.57.04-1.27h1.39l.05 1.27h-1.48Zm.2-1.11-.03.95h1.15l-.04-.95h-1.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cp1-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m41.53 60.38.04 1.11h-1.32l.04-1.11h1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m40.17 61.57.04-1.27h1.39l.05 1.27h-1.48Zm.2-1.11-.03.95h1.15l-.04-.95h-1.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cp2-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M36.66 59.57h.38v.28h.28v-.28h.39v.28h.28v-.28h.39v.64c0 .1-.08.17-.17.17h-1.38c-.09 0-.18-.08-.18-.17v-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M38.22 60.46h-1.38c-.14 0-.26-.11-.26-.25v-.68l.05-.04h.49v.28h.12v-.29h.55v.29h.12v-.28h.55v.72c0 .14-.11.25-.25.25Zm-1.48-.8v.55s.05.09.1.09h1.38s.09-.03.09-.09v-.56h-.23v.28h-.44v-.28h-.23v.28h-.44v-.28h-.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cp2-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M40.05 59.57h.38v.28h.28v-.28h.39v.28h.28v-.28h.39v.64c0 .1-.08.17-.17.17h-1.38c-.09 0-.18-.08-.18-.17v-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.6 60.46h-1.38c-.14 0-.26-.11-.26-.25v-.68l.05-.04h.49v.28h.12v-.29h.55v.29h.12v-.28h.55v.72c0 .14-.11.25-.25.25Zm-1.48-.8v.55s.05.09.1.09h1.38s.09-.03.09-.09v-.56h-.23v.28h-.44v-.28h-.23v.28h-.44v-.28h-.22Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.09 60.08c0-.2.28-.2.28 0v.49h-.28v-.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M37.38 60.79c0-.19.27-.2.26 0v.38h-.26v-.38",
    id: "cp3-3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M40.78 60.79c0-.19.27-.2.26 0v.38h-.26v-.38",
    id: "cp3-4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "castle3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "castle-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M43.66 79.87c-1.22-1.27-.63-2.45-.63-2.46 0-.01 1.27-.64 2.51.6l-1.88 1.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m41.38 79.12 1.28 1.58.93-.94c-1.18-1.19-.49-2.28-.47-2.29.02-.02 1.16-.64 2.3.45l.93-.94-1.62-1.27-3.37 3.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m42.66 80.82-1.34-1.65-.03-.05.03-.06 3.42-3.46 1.74 1.37-1.05 1.06-.06-.05c-.43-.41-.91-.62-1.42-.62-.42 0-.73.15-.78.18s-.67 1.02.48 2.17l.06.06-1.05 1.05Zm-1.17-1.7 1.18 1.46.81-.82c-.61-.64-.69-1.25-.65-1.66.02-.18.07-.34.11-.47l-1.46 1.48Zm2.47-1.93c.53 0 1.03.21 1.47.61l.82-.82-1.49-1.17-1.48 1.5c.16-.06.4-.12.68-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m42.61 80.77 3.81-3.84c.08-.08.23-.07.32.03.1.1.11.24.03.32l-3.81 3.84c-.08.08-.23.07-.32-.03-.1-.1-.11-.24-.03-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M42.82 81.25a.35.35 0 0 1-.24-.1c-.13-.13-.14-.32-.03-.44l3.81-3.84c.11-.11.31-.09.44.03.13.13.14.32.03.44l-3.81 3.84s-.12.08-.19.08Zm3.72-4.29s-.05 0-.08.03l-3.81 3.84s-.03.15.03.21c.04.04.09.06.13.06.02 0 .05 0 .08-.03l3.81-3.84s.03-.15-.03-.21a.194.194 0 0 0-.13-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M43.98 79.37c-.75-.75-.45-1.47-.45-1.47s.75-.31 1.49.42l-1.04 1.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m43.98 79.48-.06-.06c-.46-.47-.54-.92-.53-1.22 0-.14.04-.33.09-.36h.02s.18-.09.43-.09c.29 0 .72.09 1.15.51l.06.06-1.15 1.16Zm-.39-1.52c-.04.13-.17.69.39 1.29l.93-.93c-.37-.34-.73-.41-.98-.41-.16 0-.28.03-.34.05ZM40.65 78.66l3.65-3.68c.08-.08.21-.07.3.02.09.09.1.22.02.3l-3.65 3.68c-.08.08-.21.07-.3-.02-.09-.09-.1-.22-.02-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M40.83 79.11a.31.31 0 0 1-.22-.09c-.12-.12-.13-.3-.02-.41l3.65-3.68c.1-.11.3-.1.41.02.12.12.13.3.02.41l-3.65 3.68s-.12.08-.19.08Zm3.6-4.1s-.06.01-.08.03l-3.65 3.68s-.04.13.02.19c.05.05.14.06.19.02l3.65-3.68s.04-.13-.02-.19a.16.16 0 0 0-.11-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m41.04 78.9 3.49-3.52c.07-.07.21-.06.29.02.09.09.1.22.03.29l-3.49 3.52c-.07.07-.21.06-.29-.02-.09-.09-.1-.22-.03-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.24 79.35c-.08 0-.16-.03-.22-.1-.12-.12-.13-.3-.03-.41l3.49-3.52c.1-.1.29-.09.41.02.06.06.1.14.1.23 0 .07-.03.13-.07.18l-3.49 3.52s-.11.07-.18.07Zm3.42-3.93s-.05 0-.07.03l-3.49 3.52s-.03.13.03.18c.03.03.07.05.11.05.02 0 .05 0 .07-.03l3.49-3.52s.03-.05.03-.07a.16.16 0 0 0-.05-.11.16.16 0 0 0-.11-.05ZM39.77 75.39l.28-.28.2.2.2-.2-.2-.2.28-.28.2.2.2-.2-.2-.2.28-.28.46.45c.07.07.06.17 0 .24l-.99 1c-.07.07-.18.08-.25.01l-.45-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M40.34 75.96c-.07 0-.13-.02-.17-.07l-.51-.5.39-.39.2.2.09-.09-.2-.2.4-.4.2.2.09-.09-.2-.2.4-.4.51.51s.07.11.07.17c0 .07-.03.13-.08.18l-.99 1c-.05.05-.12.08-.19.08Zm-.45-.57.39.39s.04.02.06.02c.03 0 .06-.01.08-.03l.99-1s.03-.05.03-.07c0-.02 0-.04-.03-.06l-.4-.4-.17.17.2.2-.31.32-.2-.2-.17.17.2.2-.31.32-.2-.2-.16.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m41.42 74.94 1.52 1.39-.97.97-1.4-1.52.84-.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m41.97 77.42-1.51-1.63.95-.95 1.64 1.5-1.09 1.09Zm-1.28-1.63 1.29 1.4.85-.85-1.4-1.28-.74.74Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cp1-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m40.92 76.81.82.75-.93.93-.76-.81.87-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m40.81 78.61-.87-.92.98-.99.93.86-1.04 1.05Zm-.65-.92.65.69.81-.82-.7-.64-.76.77Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cp1-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m43.3 74.4.82.75-.93.93-.76-.81.87-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m43.19 76.2-.87-.92.98-.99.93.86-1.04 1.05Zm-.65-.92.65.69.81-.82-.7-.64-.76.77Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cp2-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m39.31 77.29.27-.27.2.2.2-.2-.2-.2.28-.28.2.2.2-.2-.2-.2.28-.28.46.45c.07.07.06.17 0 .24l-.97.98c-.07.07-.18.07-.24 0l-.45-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.87 77.86c-.07 0-.13-.02-.17-.07l-.51-.5.38-.38.2.2.08-.09-.2-.2.39-.39.2.2.09-.09-.2-.2.39-.39.51.51c.1.1.1.25 0 .35l-.97.98s-.12.08-.19.08Zm-.45-.57.39.39s.04.02.06.02c.03 0 .06-.01.07-.03l.97-.98s.05-.08 0-.13l-.4-.4-.16.17.2.2-.31.31-.2-.2-.16.16.2.2-.31.31-.2-.2-.16.16Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cp2-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m41.69 74.89.27-.27.2.2.2-.2-.2-.2.28-.28.2.2.2-.2-.2-.2.28-.28.46.45c.07.07.06.17 0 .24l-.97.98c-.07.07-.18.07-.24 0l-.45-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M42.26 75.46c-.07 0-.13-.02-.17-.07l-.47-.47v-.07l.35-.35.2.2.08-.09-.2-.2.39-.39.2.2.09-.09-.2-.2.39-.39.51.51c.1.1.1.25 0 .35l-.97.98s-.12.08-.19.08Zm-.45-.57.39.39s.04.02.06.02c.03 0 .06-.01.07-.03l.97-.98s.05-.08 0-.13l-.4-.4-.16.16.2.2-.31.31-.2-.2-.16.16.2.2-.31.31-.2-.2-.16.16Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.37 75.92c-.15-.13.05-.34.19-.2l.35.35-.19.2-.35-.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M40.68 77.63c-.14-.14.05-.33.19-.19l.27.27-.19.19-.27-.27",
    id: "cp3-5"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-45.202 312.766 180.004)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M43.07 75.22c-.14-.14.05-.33.19-.19l.27.27-.19.19-.27-.27",
    id: "cp3-6"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "castle-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M52.49 49.71c.04-1.76 1.29-2.18 1.3-2.18 0 0 1.35.45 1.35 2.2l-2.65-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m51.41 47.55-.22 2.02h1.32c.01-1.67 1.27-1.95 1.3-1.94.03 0 1.27.37 1.31 1.95h1.32l-.24-2.04h-4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M52.59 49.66H51.1l.23-2.2h4.94l.26 2.2h-1.49v-.08c-.03-1.53-1.23-1.87-1.24-1.87 0 0-1.19.24-1.21 1.87v.08Zm2.6-.16h1.16l-.22-1.88h-2.1c.38.18 1.11.72 1.17 1.88Zm-3.91 0h1.15c.04-1.25.75-1.71 1.14-1.87h-2.09l-.2 1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M51.1 49.59h5.41c.11 0 .21.11.21.25s-.09.25-.21.25H51.1c-.11 0-.21-.11-.21-.25s.09-.25.21-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M56.51 50.17H51.1c-.16 0-.29-.15-.29-.33s.13-.33.29-.33h5.41c.16 0 .29.15.29.33s-.13.33-.29.33Zm-5.41-.5c-.07 0-.13.08-.13.17s.06.17.13.17h5.41c.07 0 .13-.08.13-.17s-.06-.17-.13-.17H51.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M53.07 49.58c0-1.06.72-1.36.73-1.36 0 0 .75.31.75 1.36h-1.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M54.63 49.66h-1.56v-.08h-.08c0-.69.29-1.07.53-1.27 0 0 .21-.17.29-.16.06 0 .81.36.82 1.43v.08Zm-1.48-.16h1.32c-.04-.81-.54-1.12-.67-1.19-.12.06-.61.37-.64 1.19ZM51.22 46.71h5.18c.11 0 .2.1.2.22s-.09.22-.2.22h-5.18c-.11 0-.2-.1-.2-.22s.09-.22.2-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M56.4 47.24h-5.18c-.15 0-.28-.14-.28-.3s.12-.3.28-.3h5.18c.15 0 .28.14.28.3s-.12.3-.28.3Zm-5.18-.45c-.06 0-.12.07-.12.15s.05.15.12.15h5.18c.06 0 .12-.07.12-.15s-.05-.15-.12-.15h-5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M51.33 47.17h4.96c.1 0 .19.1.19.22s-.09.22-.19.22h-4.96c-.1 0-.19-.1-.19-.22s.09-.22.19-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M56.28 47.69h-4.96c-.15 0-.27-.14-.27-.3s.12-.3.27-.3h4.96c.15 0 .27.14.27.3s-.12.3-.27.3Zm-4.96-.45c-.06 0-.11.07-.11.14s.05.15.11.15h4.96c.06 0 .11-.07.11-.15s-.05-.14-.11-.14h-4.96ZM52.93 43.79h.39v.28h.29v-.28h.4v.28h.29v-.28h.4v.64c0 .1-.08.17-.18.17h-1.41c-.09 0-.18-.08-.18-.17v-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M54.52 44.67h-1.41c-.14 0-.26-.11-.26-.25v-.68l.05-.04h.5v.28h.13v-.28h.56v.28h.13v-.28h.56v.72c0 .14-.11.25-.26.25Zm-1.51-.8v.55s.05.09.1.09h1.41s.1-.03.1-.09v-.56h-.24v.28h-.45v-.28h-.24v.28h-.45v-.28h-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m54.4 44.64.09 2.06h-1.37l.09-2.06h1.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M54.57 46.78h-1.54l.1-2.22h1.35l.1 2.22Zm-1.37-.16h1.21l-.08-1.89h-1.04l-.08 1.89Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cp1-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m52.73 45.6.04 1.11h-1.32l.04-1.11h1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m51.37 46.79.04-1.27h1.39l.05 1.27h-1.48Zm.2-1.11-.03.95h1.15l-.04-.95h-1.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cp1-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m56.11 45.6.04 1.11h-1.32l.04-1.11h1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m54.76 46.79.04-1.27h1.39l.05 1.27h-1.48Zm.2-1.11-.03.95h1.15l-.04-.95h-1.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cp2-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M51.25 44.79h.38v.28h.28v-.28h.39v.28h.28v-.28h.39v.64c0 .1-.08.17-.17.17h-1.38c-.09 0-.18-.08-.18-.17v-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M52.8 45.68h-1.38c-.14 0-.26-.11-.26-.25v-.68l.05-.04h.49v.28h.12v-.29h.55v.29h.12v-.28h.55v.72c0 .14-.11.25-.25.25Zm-1.48-.8v.55s.05.09.1.09h1.38s.09-.03.09-.09v-.56h-.23v.28h-.44v-.28h-.23v.28h-.44v-.28h-.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cp2-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M54.63 44.79h.38v.28h.28v-.28h.39v.28h.28v-.28h.39v.64c0 .1-.08.17-.17.17H54.8c-.09 0-.18-.08-.18-.17v-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M56.19 45.68h-1.38c-.14 0-.26-.11-.26-.25v-.68l.05-.04h.49v.28h.12v-.29h.55v.29h.12v-.28h.55v.72c0 .14-.11.25-.25.25Zm-1.48-.8v.55s.05.09.1.09h1.38s.09-.03.09-.09v-.56h-.23v.28h-.44v-.28h-.23v.28h-.44v-.28h-.22Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M53.67 45.3c0-.2.28-.2.28 0v.49h-.28v-.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M51.97 46.01c0-.19.27-.2.26 0v.38h-.26v-.38",
    id: "cp3-7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M55.37 46.01c0-.19.27-.2.26 0v.38h-.26v-.38",
    id: "cp3-8"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "castle-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M69.62 49.71c-.04-1.76-1.29-2.18-1.3-2.18 0 0-1.35.45-1.35 2.2l2.65-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m70.7 47.55.22 2.02H69.6c-.01-1.67-1.27-1.95-1.3-1.94-.03 0-1.27.37-1.31 1.95h-1.32l.24-2.04h4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M69.52 49.66v-.08c-.01-1.63-1.21-1.87-1.22-1.87 0 0-1.19.34-1.22 1.87v.08h-1.49l.26-2.2h4.94v.09l.23 2.1h-1.49Zm-3.76-.16h1.16c.06-1.17.79-1.7 1.17-1.88h-2.1l-.22 1.88Zm2.78-1.87c.38.16 1.1.62 1.14 1.87h1.15l-.2-1.87h-2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M71.01 49.59H65.6c-.11 0-.21.11-.21.25s.09.25.21.25h5.41c.11 0 .21-.11.21-.25s-.09-.25-.21-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M71.01 50.17H65.6c-.16 0-.29-.15-.29-.33s.13-.33.29-.33h5.41c.16 0 .29.15.29.33s-.13.33-.29.33Zm-5.41-.5c-.07 0-.13.08-.13.17s.06.17.13.17h5.41c.07 0 .13-.08.13-.17s-.06-.17-.13-.17H65.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M69.04 49.58c0-1.06-.72-1.36-.73-1.36 0 0-.75.31-.75 1.36h1.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M69.12 49.66h-1.64v-.08c0-1.07.77-1.43.83-1.43s.8.34.81 1.43v.08Zm-1.48-.16h1.32c-.03-.81-.52-1.12-.64-1.19-.13.07-.64.38-.67 1.19ZM70.89 46.71h-5.18c-.11 0-.2.1-.2.22s.09.22.2.22h5.18c.11 0 .2-.1.2-.22s-.09-.22-.2-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M70.89 47.24h-5.18c-.15 0-.28-.14-.28-.3s.12-.3.28-.3h5.18c.15 0 .28.14.28.3s-.12.3-.28.3Zm-5.18-.45c-.06 0-.12.07-.12.15s.05.15.12.15h5.18c.06 0 .12-.07.12-.15s-.05-.15-.12-.15h-5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M70.78 47.17h-4.96c-.1 0-.19.1-.19.22s.09.22.19.22h4.96c.1 0 .19-.1.19-.22s-.09-.22-.19-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M70.78 47.69h-4.96c-.15 0-.27-.14-.27-.3s.12-.3.27-.3h4.96c.15 0 .27.14.27.3s-.12.3-.27.3Zm-4.96-.45c-.06 0-.11.07-.11.14s.05.15.11.15h4.96c.06 0 .11-.07.11-.15s-.05-.14-.11-.14h-4.96ZM69.18 43.79h-.39v.28h-.29v-.28h-.4v.28h-.29v-.28h-.4v.64c0 .1.08.17.18.17H69c.09 0 .18-.08.18-.17v-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M69 44.67h-1.41c-.15 0-.25-.11-.25-.25v-.72h.56v.28h.13v-.28h.56v.28h.13v-.28h.5l.06.04v.68c0 .13-.12.25-.26.25Zm-1.5-.81v.56c0 .06.05.09.1.09h1.41c.05 0 .1-.04.1-.09v-.55h-.23v.28h-.45v-.28h-.24v.28h-.45v-.28h-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m67.71 44.64-.09 2.06h1.37l-.09-2.06h-1.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m67.54 46.78.1-2.22h1.35l.1 2.21h-1.54Zm.25-2.05-.08 1.9h1.21l-.08-1.9H67.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cp1-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m69.38 45.6-.04 1.11h1.32l-.04-1.11h-1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M70.74 46.79h-1.48l.05-1.27h1.39l.04 1.27Zm-1.32-.16h1.15l-.03-.95h-1.08l-.04.95Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cp1-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m66 45.6-.04 1.11h1.32l-.04-1.11H66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M67.35 46.79h-1.48l.05-1.27h1.39l.04 1.27Zm-1.32-.16h1.15l-.03-.95h-1.08l-.04.95Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cp2-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M70.86 44.79h-.38v.28h-.28v-.28h-.39v.28h-.28v-.28h-.39v.64c0 .1.08.17.17.17h1.38c.09 0 .18-.08.18-.17v-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M70.68 45.68H69.3c-.14 0-.25-.11-.25-.25v-.72h.55v.28h.12v-.28h.55v.28h.12v-.28h.49l.06.04v.68c0 .13-.12.25-.26.25Zm-1.47-.81v.56c0 .06.05.09.09.09h1.38c.05 0 .1-.04.1-.09v-.55h-.22v.28h-.44v-.28h-.23v.28h-.44v-.28h-.23Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cp2-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M67.48 44.79h-.38v.28h-.28v-.28h-.39v.28h-.28v-.28h-.39v.64c0 .1.08.17.17.17h1.38c.09 0 .18-.08.18-.17v-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M67.3 45.68h-1.38c-.14 0-.25-.11-.25-.25v-.72h.55v.28h.12v-.28h.55v.28h.12v-.28h.49l.06.04v.68c0 .13-.12.25-.26.25Zm-1.47-.81v.56c0 .06.05.09.09.09h1.38c.05 0 .1-.04.1-.09v-.55h-.22v.28h-.44v-.28h-.23v.28h-.44v-.28h-.23Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M68.44 45.3c0-.2-.28-.2-.28 0v.49h.28v-.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M70.14 46.01c0-.19-.27-.2-.26 0v.38h.26v-.38",
    id: "cp3-9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M66.74 46.01c0-.19-.27-.2-.26 0v.38h.26v-.38",
    id: "cp3-10"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "castle-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M69.62 64.48c-.04-1.76-1.29-2.18-1.3-2.18 0 0-1.35.45-1.35 2.2l2.65-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m70.7 62.33.22 2.02H69.6c-.01-1.67-1.27-1.95-1.3-1.94-.03 0-1.27.37-1.31 1.95h-1.32l.24-2.04h4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M69.52 64.44v-.08c-.01-1.63-1.21-1.87-1.22-1.87 0 0-1.19.34-1.22 1.87v.08h-1.49l.26-2.2h4.94v.09l.23 2.1h-1.49Zm-3.76-.16h1.16c.06-1.17.79-1.7 1.17-1.87h-2.1l-.22 1.87Zm2.78-1.87c.38.16 1.1.62 1.14 1.87h1.15l-.2-1.87h-2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M71.01 64.37H65.6c-.11 0-.21.11-.21.25s.09.25.21.25h5.41c.11 0 .21-.11.21-.25s-.09-.25-.21-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M71.01 64.95H65.6c-.16 0-.29-.15-.29-.33s.13-.33.29-.33h5.41c.16 0 .29.15.29.33s-.13.33-.29.33Zm-5.41-.5c-.07 0-.13.08-.13.17s.06.17.13.17h5.41c.07 0 .13-.08.13-.17s-.06-.17-.13-.17H65.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M69.04 64.36c0-1.06-.72-1.36-.73-1.36 0 0-.75.31-.75 1.36h1.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M69.12 64.44h-1.64v-.08c0-1.07.77-1.43.83-1.43s.8.34.81 1.43v.08Zm-1.48-.16h1.32c-.03-.81-.52-1.12-.64-1.19-.13.07-.64.37-.67 1.19ZM70.89 61.49h-5.18c-.11 0-.2.1-.2.22s.09.22.2.22h5.18c.11 0 .2-.1.2-.22s-.09-.22-.2-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M70.89 62.02h-5.18c-.15 0-.28-.14-.28-.3s.12-.3.28-.3h5.18c.15 0 .28.14.28.3s-.12.3-.28.3Zm-5.18-.45c-.06 0-.12.07-.12.15s.05.15.12.15h5.18c.06 0 .12-.07.12-.15s-.05-.15-.12-.15h-5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M70.78 61.94h-4.96c-.1 0-.19.1-.19.22s.09.22.19.22h4.96c.1 0 .19-.1.19-.22s-.09-.22-.19-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M70.78 62.47h-4.96c-.15 0-.27-.14-.27-.3s.12-.3.27-.3h4.96c.15 0 .27.14.27.3s-.12.3-.27.3Zm-4.96-.45c-.06 0-.11.07-.11.14s.05.15.11.15h4.96c.06 0 .11-.07.11-.15s-.05-.14-.11-.14h-4.96ZM69.18 58.57h-.39v.28h-.29v-.28h-.4v.28h-.29v-.28h-.4v.64c0 .1.08.17.18.17H69c.09 0 .18-.08.18-.17v-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M69 59.45h-1.41c-.15 0-.25-.11-.25-.25v-.72h.56v.28h.13v-.28h.56v.28h.13v-.28h.5l.06.04v.68c0 .13-.12.25-.26.25Zm-1.5-.81v.56c0 .06.05.09.1.09h1.41c.05 0 .1-.04.1-.09v-.55h-.23v.28h-.45v-.28h-.24v.28h-.45v-.28h-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m67.71 59.42-.09 2.06h1.37l-.09-2.06h-1.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m67.54 61.56.1-2.22h1.35l.1 2.21h-1.54Zm.25-2.05-.08 1.9h1.21l-.08-1.9H67.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cp1-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m69.38 60.38-.04 1.11h1.32l-.04-1.11h-1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M70.74 61.57h-1.48l.05-1.27h1.39l.04 1.27Zm-1.32-.16h1.15l-.03-.95h-1.08l-.04.95Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cp1-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m66 60.38-.04 1.11h1.32l-.04-1.11H66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M67.35 61.57h-1.48l.05-1.27h1.39l.04 1.27Zm-1.32-.16h1.15l-.03-.95h-1.08l-.04.95Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cp2-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M70.86 59.57h-.38v.28h-.28v-.28h-.39v.28h-.28v-.28h-.39v.64c0 .1.08.17.17.17h1.38c.09 0 .18-.08.18-.17v-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M70.68 60.46H69.3c-.14 0-.25-.11-.25-.25v-.72h.55v.28h.12v-.28h.55v.28h.12v-.28h.49l.06.04v.68c0 .13-.12.25-.26.25Zm-1.47-.81v.56c0 .06.05.09.09.09h1.38c.05 0 .1-.04.1-.09v-.55h-.22v.28h-.44v-.28h-.23v.28h-.44v-.28h-.23Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cp2-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M67.48 59.57h-.38v.28h-.28v-.28h-.39v.28h-.28v-.28h-.39v.64c0 .1.08.17.17.17h1.38c.09 0 .18-.08.18-.17v-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M67.3 60.46h-1.38c-.14 0-.25-.11-.25-.25v-.72h.55v.28h.12v-.28h.55v.28h.12v-.28h.49l.06.04v.68c0 .13-.12.25-.26.25Zm-1.47-.81v.56c0 .06.05.09.09.09h1.38c.05 0 .1-.04.1-.09v-.55h-.22v.28h-.44v-.28h-.23v.28h-.44v-.28h-.23Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M68.44 60.08c0-.2-.28-.2-.28 0v.49h.28v-.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M70.14 60.79c0-.19-.27-.2-.26 0v.38h.26v-.38",
    id: "cp3-11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M66.74 60.79c0-.19-.27-.2-.26 0v.38h.26v-.38",
    id: "cp3-12"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "castle3-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "castle-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M63.86 79.87c1.22-1.27.63-2.45.63-2.46 0-.01-1.27-.64-2.51.6l1.88 1.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m66.14 79.12-1.28 1.58-.93-.94c1.18-1.19.49-2.28.47-2.29-.02-.02-1.16-.64-2.3.45l-.93-.94 1.62-1.27 3.37 3.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m64.87 80.82-1.05-1.05.06-.06c1.15-1.16.47-2.17.47-2.18-.03-.02-.35-.17-.77-.17-.51 0-.99.21-1.42.62l-.06.05-1.05-1.06 1.74-1.37 3.47 3.51-.04.05-1.34 1.65Zm-.83-1.06.82.82 1.18-1.46-1.46-1.48c.05.12.1.29.11.47.04.4-.04 1.01-.65 1.65Zm-2.76-2.78.82.82c.45-.4.94-.61 1.47-.61.29 0 .53.06.68.12l-1.48-1.5-1.49 1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m64.92 80.77-3.81-3.84c-.08-.08-.23-.07-.32.03-.1.1-.11.24-.03.32l3.81 3.84c.08.08.23.07.32-.03.1-.1.11-.24.03-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M64.7 81.25c-.07 0-.14-.03-.19-.08l-3.81-3.84c-.11-.11-.1-.31.03-.44.12-.12.33-.14.44-.03l3.81 3.84c.11.11.1.31-.03.44-.07.07-.16.1-.24.1Zm-3.72-4.29s-.09.02-.13.06c-.07.06-.08.16-.03.21l3.81 3.84s.06.03.08.03.09-.02.13-.06c.07-.07.08-.16.03-.21l-3.81-3.84s-.06-.03-.08-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M63.54 79.37c.75-.75.45-1.47.45-1.47s-.75-.31-1.49.42l1.04 1.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m63.54 79.48-1.15-1.16.06-.06c.43-.42.86-.51 1.15-.51.25 0 .41.06.43.07h.02s.08.23.09.38c.01.3-.07.76-.53 1.22l-.06.06Zm-.93-1.16.93.93c.56-.61.43-1.16.39-1.29-.05-.02-.18-.05-.34-.05-.24 0-.61.07-.98.41ZM66.88 78.66l-3.65-3.68c-.08-.08-.21-.07-.3.02-.09.09-.1.22-.02.3l3.65 3.68c.08.08.21.07.3-.02.09-.09.1-.22.02-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M66.69 79.11c-.07 0-.14-.03-.19-.08l-3.65-3.68c-.11-.11-.1-.29.02-.41.11-.11.31-.12.41-.02l3.65 3.68c.11.11.1.29-.02.41a.31.31 0 0 1-.22.09Zm-3.6-4.1s-.08.02-.11.05c-.06.06-.06.14-.02.19l3.65 3.68s.13.04.19-.02.06-.14.02-.19l-3.65-3.68s-.05-.03-.08-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m66.48 78.9-3.49-3.52c-.07-.07-.21-.06-.29.02-.09.09-.1.22-.03.29l3.49 3.52c.07.07.21.06.29-.02.09-.09.1-.22.03-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M66.28 79.35c-.07 0-.13-.03-.18-.07l-3.49-3.52s-.07-.11-.07-.18c0-.08.04-.16.1-.23.11-.11.31-.12.41-.02l3.49 3.52c.1.11.09.29-.03.41-.06.06-.14.1-.22.1Zm-3.42-3.93s-.08.02-.11.05a.16.16 0 0 0-.05.11c0 .02 0 .05.03.07l3.49 3.52s.05.03.07.03c.04 0 .08-.02.11-.05.06-.06.07-.14.03-.18l-3.49-3.52s-.05-.03-.07-.03ZM67.75 75.39l-.28-.28-.2.2-.2-.2.2-.2-.28-.28-.2.2-.2-.2.2-.2-.28-.28-.46.45c-.07.07-.06.17 0 .24l.99 1c.07.07.18.08.25.01l.45-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M67.18 75.96c-.07 0-.14-.03-.19-.08l-.99-1s-.08-.12-.08-.18.03-.12.07-.17l.51-.51.4.4-.2.2.09.09.2-.2.4.4-.2.2.09.09.2-.2.35.35.03.05-.49.49s-.1.07-.17.07Zm-.68-1.71-.4.4s-.03.04-.03.06c0 .02.01.05.03.07l.99 1s.05.03.08.03c.01 0 .04 0 .06-.02l.39-.39-.16-.16-.2.2-.31-.32.2-.2-.17-.17-.2.2-.31-.32.2-.2-.17-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m66.1 74.94-1.52 1.39.97.97 1.4-1.52-.84-.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m65.55 77.42-1.09-1.09 1.64-1.5.95.95-1.51 1.63Zm-.86-1.08.85.85 1.29-1.4-.74-.74-1.4 1.28Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cp1-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m66.6 76.81-.82.75.93.93.76-.81-.87-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m66.72 78.61-1.04-1.05.93-.86.98.99-.87.92Zm-.81-1.05.81.82.65-.69-.76-.77-.7.64Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cp1-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m64.22 74.4-.82.75.93.93.76-.81-.87-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m64.33 76.2-1.04-1.05.93-.86.98.99-.87.92Zm-.81-1.05.81.82.65-.69-.76-.77-.7.64Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cp2-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m68.22 77.29-.27-.27-.2.2-.2-.2.2-.2-.28-.28-.2.2-.2-.2.2-.2-.28-.28-.46.45c-.07.07-.06.17 0 .24l.97.98c.07.07.18.07.24 0l.45-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M67.65 77.86c-.07 0-.14-.03-.19-.08l-.97-.98c-.1-.1-.1-.25 0-.35l.51-.51.39.39-.2.2.09.09.2-.2.39.39-.2.2.08.09.2-.2.35.35v.07l-.47.47s-.1.07-.17.07ZM67 76.17l-.4.4s-.03.09 0 .13l.97.98s.05.03.07.03c.01 0 .04 0 .06-.02l.39-.39-.16-.16-.2.2-.31-.31.2-.2-.16-.16-.2.2-.31-.31.2-.2-.16-.17Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cp2-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m65.83 74.89-.27-.27-.2.2-.2-.2.2-.2-.28-.28-.2.2-.2-.2.2-.2-.28-.28-.46.45c-.07.07-.06.17 0 .24l.97.98c.07.07.18.07.24 0l.45-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M65.27 75.46c-.07 0-.14-.03-.19-.08l-.97-.98c-.1-.1-.1-.25 0-.35l.51-.51.39.39-.2.2.09.09.2-.2.39.39-.2.2.08.09.2-.2.36.36-.02.07-.47.46s-.1.07-.17.07Zm-.65-1.69-.4.4s-.03.09 0 .13l.97.98s.05.03.07.03c.01 0 .04 0 .06-.02l.39-.39-.16-.16-.2.2-.31-.31.2-.2-.16-.16-.2.2-.31-.31.2-.2-.16-.16Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M66.15 75.92c.15-.13-.05-.34-.19-.2l-.35.35.19.2.35-.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M66.85 77.63a.135.135 0 0 0-.19-.19l-.27.27.19.19.27-.27",
    id: "cp3-13"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 479.792 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M64.45 75.22a.135.135 0 0 0-.19-.19l-.27.27.19.19.27-.27",
    id: "cp3-14"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "quina"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M51.45 56.71c0 .71.27 1.35.71 1.82.44.47 1.04.76 1.69.76s1.26-.29 1.69-.75c.43-.47.7-1.11.7-1.82v-3.44h-4.78v3.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.54 54.11a.47.47 0 1 1 .001.939.47.47 0 0 1-.001-.939ZM55.2 54.11a.47.47 0 1 1 .001.939.47.47 0 0 1-.001-.939ZM53.87 55.39a.47.47 0 1 1 .001.939.47.47 0 0 1-.001-.939ZM52.54 56.72a.47.47 0 1 1 .001.939.47.47 0 0 1-.001-.939ZM55.19 56.72a.47.47 0 1 1 .001.939.47.47 0 0 1-.001-.939Z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "quina-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M51.45 65.01c0 .71.27 1.35.71 1.82.44.47 1.04.76 1.69.76s1.26-.29 1.69-.75c.43-.47.7-1.11.7-1.82v-3.44h-4.78v3.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.54 62.41a.47.47 0 1 1 .001.939.47.47 0 0 1-.001-.939ZM55.2 62.41a.47.47 0 1 1 .001.939.47.47 0 0 1-.001-.939ZM53.87 63.69a.47.47 0 1 1 .001.939.47.47 0 0 1-.001-.939ZM52.54 65.02a.47.47 0 1 1 .001.939.47.47 0 0 1-.001-.939ZM55.19 65.02a.47.47 0 1 1 .001.939.47.47 0 0 1-.001-.939Z"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "quina-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M51.45 73.24c0 .71.27 1.35.71 1.82.44.47 1.04.76 1.69.76s1.26-.29 1.69-.75c.43-.47.7-1.11.7-1.82v-3.44h-4.78v3.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.54 70.64a.47.47 0 1 1 .001.939.47.47 0 0 1-.001-.939ZM55.2 70.64a.47.47 0 1 1 .001.939.47.47 0 0 1-.001-.939ZM53.87 71.91a.47.47 0 1 1 .001.939.47.47 0 0 1-.001-.939ZM52.54 73.25a.47.47 0 1 1 .001.939.47.47 0 0 1-.001-.939ZM55.19 73.24a.47.47 0 1 1 .001.939.47.47 0 0 1-.001-.939Z"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "quina-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M44.81 65.01c0 .71.27 1.35.71 1.82.44.47 1.04.76 1.69.76s1.26-.29 1.69-.75c.43-.47.7-1.11.7-1.82v-3.44h-4.78v3.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.91 62.41a.47.47 0 1 1 .001.939.47.47 0 0 1-.001-.939ZM48.56 62.41a.47.47 0 1 1 .001.939.47.47 0 0 1-.001-.939ZM47.23 63.69a.47.47 0 1 1 .001.939.47.47 0 0 1-.001-.939ZM45.91 65.02a.47.47 0 1 1 .001.939.47.47 0 0 1-.001-.939ZM48.56 65.02a.47.47 0 1 1 .001.939.47.47 0 0 1-.001-.939Z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "quina-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M58.06 65.01c0 .71.27 1.35.71 1.82.44.47 1.04.76 1.69.76s1.26-.29 1.69-.75c.43-.47.7-1.11.7-1.82v-3.44h-4.78v3.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.16 62.41a.47.47 0 1 1 .001.939.47.47 0 0 1-.001-.939ZM61.82 62.41a.47.47 0 1 1 .001.939.47.47 0 0 1-.001-.939ZM60.49 63.69a.47.47 0 1 1 .001.939.47.47 0 0 1-.001-.939ZM59.16 65.02a.47.47 0 1 1 .001.939.47.47 0 0 1-.001-.939ZM61.81 65.02a.47.47 0 1 1 .001.939.47.47 0 0 1-.001-.939Z"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64 1.28c34.56 0 62.72 28.16 62.72 62.72S98.56 126.72 64 126.72 1.28 98.56 1.28 64 29.44 1.28 64 1.28M64 0C28.59 0 0 28.59 0 64s28.59 64 64 64 64-28.59 64-64S99.41 0 64 0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.24 11.52s4.69 19.63 39.25 26.88 34.99 37.97 34.99 37.97c0-1.28.85-3.41 1.28-4.69.85-3.41 1.71-7.68 1.71-11.52.43-12.37-3.84-24.32-11.52-33.71-6.83-8.11-15.79-14.51-26.03-16.64-13.23-2.99-26.88-2.13-39.68 1.71Z",
    style: {
      isolation: "isolate",
      opacity: 0.2,
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPtEu);
export default __webpack_public_path__ + "static/media/pt_eu.07402ce75f67148983aedfd26a718428.svg";
export { ForwardRef as ReactComponent };